import React, { type PropsWithChildren } from 'react';

import { Grid, Box } from '@atlaskit/primitives/compiled';

import { cssMap, cx } from '@atlaskit/css';

import { ContentLayoutSection } from './content-layout-section/index.tsx';
import { ImageLayoutSection } from './image-layout-section/index.tsx';
import { Controls } from './content-layout-section/controls/index.tsx';
import { ControlItem } from './content-layout-section/controls/control-item/index.tsx';
import { ExitButton } from './exit-button/index.tsx';

const gridStyles = cssMap({
	grid: {
		gridTemplateColumns: '1fr 1fr',
	},
	root: {
		height: '100%',
		maxHeight: '100%',
		maxWidth: '100%',
		minHeight: '536px',
		position: 'relative',
	},
});

type OnboardingGridType = {
	enableCrossButton: boolean;
	onClose?: () => void;
};

const OnboardingGrid = ({
	children,
	enableCrossButton = true,
	onClose,
}: PropsWithChildren<OnboardingGridType>) => {
	return (
		<Box xcss={gridStyles.root}>
			<Grid xcss={cx(gridStyles.grid)}>{children}</Grid>
			{enableCrossButton && onClose && <ExitButton onClose={onClose} />}
		</Box>
	);
};

OnboardingGrid.ContentSection = ContentLayoutSection;
OnboardingGrid.ImageSection = ImageLayoutSection;

OnboardingGrid.Controls = Controls;
OnboardingGrid.ControlItem = ControlItem;

export { OnboardingGrid };
